import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogImage?: string;
}

export default function SEO({ title, description, keywords, canonicalUrl, ogImage }: SEOProps) {
  useEffect(() => {
    const baseUrl = 'http://dnchemical.com/';

    document.title = title;
    setMeta('description', description);
    setMeta('keywords', keywords);

    setMeta('og:title', title);
    setMeta('og:description', description);
    setMeta('og:type', 'website');
    setMeta('og:url', canonicalUrl || baseUrl);
    if (ogImage) {
      setMeta('og:image', ogImage);
    }

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    if (ogImage) {
      setMeta('twitter:image', ogImage);
    }

    const canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (canonicalLink) {
      canonicalLink.href = canonicalUrl || baseUrl;
    }

    return () => {};
  }, [title, description, keywords, canonicalUrl, ogImage]);

  return null;
}

function setMeta(name: string, content: string): void {
  let el = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    if (name.startsWith('og:') || name.startsWith('twitter:')) {
      el.setAttribute('property', name);
    } else {
      el.setAttribute('name', name);
    }
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}